import { Card, CardContent, CardContentProps, Typography, TypographyProps } from '@mui/material';
import React from 'react';
import { spacing } from 'src/Common/Helper/ThemeHelper';

export const fadeTimeout = 2000;
export const countUpTime = 1500;
export const saturation = 400;
export const chartHeight = 82;
export const chartWidth = 82;
export const chartInnerRadius = 30;
export const chartOuterRadius = 41;

const titleFontSize = 24;
const boldFontWeight = 700;

export const SystemStatusCardTitle = (props: TypographyProps): React.JSX.Element => (
  <Typography
    color={'textPrimary'}
    gutterBottom
    sx={{
      fontSize: 20,
      fontWeight: boldFontWeight,
      textAlign: 'center',
    }}
    {...props}
  >
    {props.children}
  </Typography>
);

export const SystemStatusCardText = (props: TypographyProps): React.JSX.Element => (
  <Typography
    color={'textPrimary'}
    sx={{
      fontSize: titleFontSize,
      fontWeight: boldFontWeight,
      textAlign: 'center',
      marginTop: (theme) => spacing(theme) * 3,
      marginBottom: (theme) => spacing(theme) / 2,
    }}
    {...props}
  >
    {props.children}
  </Typography>
);

export const SystemStatusCardCaption = (props: TypographyProps): React.JSX.Element => (
  <Typography
    color={'textPrimary'}
    sx={{
      fontSize: 12,
      textAlign: 'center',
    }}
    {...props}
  >
    {props.children}
  </Typography>
);

export const SystemStatusCard = ({
  title,
  children,
}: {
  title: string;
  children: CardContentProps['children'];
}): React.JSX.Element => (
  <Card
    sx={{
      boxShadow: 'none',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: (theme) => theme.palette.text.secondary,
      borderRadius: 8,
    }}
  >
    <CardContent sx={{ p: 2 }}>
      <SystemStatusCardTitle>{title}</SystemStatusCardTitle>
      {children}
    </CardContent>
  </Card>
);
